import React from 'react';
import Button from '../../../components/base/Button';

const CTASection: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-teal-900 to-blue-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/cb2592874647798152bb04b6ed0f76dd.jpg')`
        }}
      ></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Yolculuğunuz <span className="text-teal-400">Bugün Başlasın</span>
          </h2>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto opacity-90">
            Hedeflerinize ulaşmak için ilk adımı atın. Ücretsiz ön görüşme ile 
            size nasıl yardımcı olabileceğimi keşfedin.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-3xl text-teal-400"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Ücretsiz Ön Görüşme</h3>
              <p className="text-gray-300">40 dakikalık tanışma seansı</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-target-line text-3xl text-blue-400"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Hedef Belirleme</h3>
              <p className="text-gray-300">Net ve ölçülebilir hedefler</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-3xl text-purple-400"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Başarıya Ulaşın</h3>
              <p className="text-gray-300">Kanıtlanmış metodoloji</p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button 
              href="/ucretsiz-gorusme" 
              size="lg" 
              className="text-lg px-10 py-4 bg-teal-600 hover:bg-teal-700"
            >
              <i className="ri-calendar-line mr-2"></i>
              Ücretsiz Ön Görüşme Rezervasyonu
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="text-lg px-10 py-4 border-white text-white hover:bg-white hover:text-gray-900"
              onClick={() => {
                const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                if (widget) widget.click();
              }}
            >
              <i className="ri-chat-3-line mr-2"></i>
              AI Asistan ile Sohbet Et
            </Button>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-8 text-sm opacity-80">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-teal-400"></i>
              <span>ICF Akredite Koç</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-time-line text-blue-400"></i>
              <span>25+ Yıl Deneyim</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-user-heart-line text-purple-400"></i>
              <span>500+ Başarılı Koçluk</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;